<template>
  <!-- 編輯頁面本體-->
  <div class="incsall ">
    <!--刪除區塊-->
    <DeleteModal :deleteModal="deleteModal" @init="init()"></DeleteModal>
 
    <!--要有檢視權限-->
    <div v-if="pagepermission.isView">
      <div v-if="!detail">
        <!--列表及查詢區塊-->
          <b-row
            ><b-col>
              <b-form-input
                v-model="search.keywords"
                placeholder="請輸入關鍵字"
                maxlength="100"
              ></b-form-input></b-col
            >
            <b-col>
              <b-form-datepicker
                placeholder="請選擇開始日期"
                v-model="search.startDate"
                class="mb-2"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
              ></b-form-datepicker>
            </b-col>
            ~
            <b-col>
              <b-form-datepicker
                placeholder="請選擇結束日期"
                v-model="search.OverDate"
                class="mb-2"
                :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <b-form-select
                v-model="search.status"
                :options="statusSearchOptions"
                class="only-button-down"
              ></b-form-select></b-col
            >
            <b-col>
              <b-form-select
                v-model="search.langurage"
                :options="langSearchOptions"
                class="only-button-down"
              ></b-form-select></b-col
            >
            <b-col cols="2"
              ><b-button @click="cancelSearch" v-if="checkSearchIsEmpty()==true" title="清空查詢條件">
                <b-icon icon="x-circle"></b-icon></b-button
              ><b-button @click="init" title="開始查詢">
                <b-icon icon="search"></b-icon></b-button
            ></b-col>
            <b-col cols="2"
              ><b-button 
                @click="_go('?lang='+lang+'&PJID='+PJ_ID+'&modal='+modal+'&id=null')"
                v-if="pagepermission.isInsert"
                >新增</b-button
              ></b-col
            ></b-row
          >
          <b-table-simple>
            <b-thead>
              <b-tr>
                <b-th>語系</b-th>
                <b-th>標題</b-th>
                <b-th>上下架日期</b-th>
                <b-th>狀態</b-th>
                <b-th>異動人員</b-th>
                <b-th>異動日期</b-th>
                <b-th>修改</b-th
                >
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="item in contentList" :key="item.id+'-'+ item.langurage">
				<b-td>{{ langSearchOptions.find(x => x.value == item.langurage).text }}</b-td>
                <b-td>
                  {{ htmlDecode(item.title) }}
                </b-td>
                <b-td>{{ dateFormat(item.startDate) }} ~ <br> {{ dateFormat(item.endDate) }}</b-td>
                <b-td>{{ statusOptions.find(x => x.value == item.deployStatus).text }}</b-td>
                <b-td>{{ item.modifierName?item.modifierName : item.creatorName }}</b-td>
                <b-td>{{ item.modifierName? dateFormat(item.modifyDate) : dateFormat(item.createDate) }}</b-td>
                <b-td class="btn_edit">
                  <b-button
                    variant="info"
                    class="mr-3"
                    @click="_go('?lang='+item.langurage+'&PJID='+PJ_ID+'&modal='+modal+'&id='+item.id)"
                    v-if="pagepermission.isUpdate"
                    >編輯</b-button
                  >
                  <a
                    href="javascript:"
                    class="btn_delete"
                    v-if="pagepermission.isDelete"
                    @click="functionDelete(item)"
                    ><img src="/images/backend/del_icon.png" alt="刪除icon"/></a
                ></b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          <div class="page mt-2">
            <span class="pagination-total">共 {{Math.ceil(pagination.rows/pagination.perPage)}} 頁．{{pagination.rows}}筆資料</span>
            <b-pagination
              class="pagination light-theme simple-pagination"
              v-model="pagination.page"
              :total-rows="pagination.rows"
              :per-page="pagination.perPage"
              aria-controls="my-table"
            ></b-pagination>
          </div>
      </div>
      <div v-else>
          <!--內容區塊-->
          <div class="incsal">
            <div class="btare">
              <div class="backrul">
                <a :href="'?lang='+lang+'&PJID='+PJ_ID+'&modal='+modal">返回查詢結果</a>
              </div>
            </div>
            
            <!--切換語系區塊-->
            <div class="language_div p-3 mb-2">
                <button id="toTw" :class="'btn '+(this.lang == '1' ?'btn-danger selected':'btn-secondary')" @click="toLang('tw')">中文版</button>
                <button id="toEn" :class="'btn '+(this.lang == '2' ?'btn-danger selected':'btn-secondary')" @click="toLang('en')">英文版</button>
            </div>

            <!--標題區塊-->
            <div class="title_div p-3 mb-2 bkbor">
                <label class="text-danger" for="title">{{(lang==1)?"中文":"英文"}}標題*</label>
                <b-form-input 
                    name="title"
                    placeholder="請輸入標題"
                    required
                    maxlength="200" v-model="contentDetail.title">
                </b-form-input>
            </div>

            <!--設定區塊-->
            <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" >
                <b-row>
                    <b-col>
                        <label class="text-danger" for="startDate">上架時間*</label>
                        <b-form-datepicker 
                            name="startDate"
                            class="mb-2"  
                            clear-button
                            placeholder="選擇上架日期" 
                            v-model="contentDetail.startDate"
                            :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col>
                        <label for="endDate">下架時間</label>
                        <b-form-datepicker 
                            name="endDate"
                            class="mb-2"  
                            reset-button
                            reset-button-text="清除日期"
                            placeholder="選擇下架日期" 
                            v-model="contentDetail.endDate"
                            :date-format-options="{ year: 'numeric', month: 'long', day: 'numeric' }">
                        </b-form-datepicker>
                    </b-col>
                    <b-col>
                        <label class="text-danger" for="Displaystatus">發布狀態*</label>
                        <b-form-select 
                            name="Displaystatus"
                            class="only-button-down"
                            v-model="contentDetail.deployStatus"
                            :options="statusOptions">
                        </b-form-select>
                    </b-col>
                </b-row>
            </b-form-group>
            <!--活動花絮 需上傳相簿預設圖-->
            <b-row >
              <b-col>
                  <label class="text-danger">上傳圖片* (W:460 x H:300 px)</label>
                  <div>
                      <b-form-file
                        accept=".jpg,.png"
                        v-model="contentDetail.file"
                        ref="file-input"
                        class="mb-2"
                      ></b-form-file>
                  </div>
              </b-col>
              <b-col>
                  <label>預覽</label>
                  <div class="rulnal" v-if="contentDetail.filePath != null">
                    <div class="viewvd">
                      <img :src="'/filestore'+contentDetail.filePath" alt="imgPathError" width="250" />
                    </div>
                  </div>
                  <div v-else>未上傳圖片</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>圖檔</label>
                <div v-if="permission.isInsert">
                  <b-button v-b-modal.modal-uploadFile>上傳圖檔</b-button>
                </div>
                <b-modal
                  id="modal-uploadFile"
                  v-model="uploadFileShow"
                  title="上傳圖檔"
                  ok-only
                >
                  <template #modal-footer>
                    <b-overlay :show="uploading" rounded="sm">
                      <button
                        v-b-modal.modal-close_visit
                        class="btn btn-success btn-sm m-1"
                        @click="uploadSaveFile"
                      >
                        上傳
                      </button>
                    </b-overlay>
                  </template>
                  <div>
                    <label>圖檔上傳</label>
                    <b-form-file
                      accept=".jpg,.png,.gif"
                      v-model="uploadFile.fileName"
                      ref="file-input"
                      class="mb-2"
                    ></b-form-file>
                  </div>
                </b-modal>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-2">
                <ul v-if="contentDetail.outExFile != null && contentDetail.outExFile.length != 0">
                  <li v-for="item in contentDetail.outExFile" :key="item.id" class="mt-2">
                    <div class="row">
                      <b-button
                        v-if="permission.isDelete"
                        @click="DeleteFile(item)"
                        class="mr-3">
                        刪除
                      </b-button>
                      <div style="color: black"><a :href="item.filePath" target="_blank">{{ item.fileName }}</a></div>
                    </div>
                  </li>
                </ul>
                <div v-else>無檔案</div>
              </b-col>
            </b-row>
            
            <!--後台系統紀錄區塊 (若無資料則不顯示)-->
            <b-form-group class="status_div p-3 mb-2 bkbor" label-size="lg" 
                v-if="contentDetail.creatorName ||contentDetail.modifierName">
                <!--建檔記錄-->
                <b-row 
                    v-if="contentDetail.creatorName">
                    <b-col>
                        <span>建檔紀錄：</span>
                        <!--建檔記錄格式 = 建檔帳號(建立時間 yyyy-mm-dd HH:MM:ss) -->
                        <span>{{contentDetail.creatorName}}({{ datetimeFormatFloat(contentDetail.createDate) }})</span>
                    </b-col>
                </b-row>
                <!--異動紀錄-->
                <b-row 
                    v-if="contentDetail.modifierName">
                    <b-col>
                        <span>異動紀錄：</span>
                        <!--異動記錄格式 = 異動帳號(異動時間 yyyy-mm-dd HH:MM:ss) -->
                        <span>{{contentDetail.modifierName}}({{datetimeFormatFloat(contentDetail.modifyDate) }})</span>
                    </b-col>
                </b-row>
            </b-form-group>
            <div class="Operation_div"> 
              <b-button id="save_btn" 
                  class="btn btn-secondary"
                  v-if="pagepermission.isInsert || pagepermission.isUpdate" 
                  @click="save" >儲存</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import DeleteModal from "../../Tool/deleteModal.vue";
  export default {
    components: {
      DeleteModal,
    },
    data() {
      return {
        detail: false,
        //以POST方式傳送
        formData: new FormData(),
        //查詢條件
        search: { status: null, langurage: null },
        initSeach: false,
        //頁數設定  
        pagination: {
          perPage: 8,
          page: 1,
          rows: 5,
        },
        contentList: [],
        contentDetail: {},
        //刪除模板
        deleteModal: {
          id: null,
          classes: null,
          parent: null,
          show: false,
          type: "LatestNews",
        },
        //發布狀態查詢選項		  
        statusSearchOptions: [
          { value: null, text: '全部發布狀態' },
          { value: 1, text: '開啟' },
          { value: 2, text: '關閉' },
        ],
        //語系查詢選項
        langSearchOptions: [
          { value: null, text: '全部語系' },
          { value: 1, text: '中文版' },
          { value: 2, text: '英文版' },
        ],
        //發布狀態編輯選項				  
        statusOptions: [
          { value: null, text: '請選擇' },
          { value: 1, text: '開啟' },
          { value: 2, text: '關閉' },
        ],
        //開啟上傳視窗
        uploadFileShow: false,
        //刪除上傳ID
        fileId: null,
        //上傳檔案JSON
        uploadFile: {
          fileName: null,
        },
        //權限編號
        PJ_ID:"",
        //類別編號
        typeId: "1",
        //文章編號
        id:"", 
        //語系
        lang:"1",
        //樣式編號
        modal:"2",
        //暫時編號(新增資料使用)
        tempId:"",
        //是否開啟刪除介面
        deleteConfirm: false,
        //單位權限
        pagepermission:{},		  
        uploading:false,
        
        //API設定區
        apiLatestNews: (data) => this.userRequest.post("bicd/LatestNews", data),
        apiLatestNews2: (data) => this.userRequest.post("bicd/LatestNews2", data),
        apiLatestNewsFile:(data) => this.userRequest.post("bicd/LatestNewsFile",data),
        apiLatestNewsFile2:(data) => this.userRequest.post("bicd/LatestNewsFile2",data),
      };
    },
    props:["value"],
    computed: {},
    mounted() {
      this.init();
    },
    watch: {
      "$route.query"() {
        this.init();
      },
      "pagination.page"() {
        this.init();
      },
      value(){
          //初始化
          this.init();
      }, 
      //權限
      permission(){
          this.pagepermission = this.permission;
      }
    },
    methods: {
      async init() {
        //類別編號
        this.PJ_ID = this.value.PJID;
        //類別內部編號
        this.typeId = Number(this.value.typeId);
        //文章編號
        this.id = this.value.id;
        //語系
        this.lang = this.value.lang?this.value.lang : 1;
        //樣式編號
        this.modal = this.value.modal;
        
        //取得畫面權限
        this.getPermission(this.PJ_ID);

        this.initSeach = false; 

        if (this.id == undefined) {
          //查詢文章內容
          window.scrollTo(0, 0);
          this.detail = false;  
          this.initSeach = true;  
                        
          try {
            this.contentList = {};
            let jsonReq = {
              TYPE: "LIST",
              VerifyCode:this.PJ_ID,
              LatestNews_SELECT: {
                langurage: this.search.langurage,
                typeId: this.typeId,
                keywords: this.search.keywords,
                startDate: this.search.startDate,
                endDate: this.search.endDate,
                deployStatus: this.search.status,
                pageIndex: this.pagination.page,
                pageSize: this.pagination.perPage,
              },
            };
            let resToken = await this.userRequest.post(
                "bicd/Token"
            ); 
            jsonReq.Token = resToken.data;
            let res = await this.userRequest.post(
                "bicd/LatestNews",
                jsonReq
            );
            let json = JSON.parse(res.data);
            if (json.Status) {
                let jsonData = JSON.parse(json.Data);
                this.contentList = jsonData.outData;
                this.pagination.rows = jsonData.totalCount;
            }
          } catch (err) {
              console.log(err);
          }
          this.checkSearchIsEmpty();
        } else {
          this.detail = true;  
          this.initSeach = false; 
          if(this.id == "null"){
            //未具有ID編號(新增項)
            //新增文章內容
            //若為新增時創建一個提供暫存檔案讀取的暫時編號
            this.tempId = crypto.randomUUID();
            this.contentDetail = {};
            this.contentDetail = {
                startDate: new Date().toISOString(),
                linkMethod: '_self',
                deployStatus: null,
                sort: 1,
                creatorName: sessionStorage.getItem("LoginName"),
                createDate: new Date().toISOString(),
                modifierName: sessionStorage.getItem("LoginName"),
                modifyDate: new Date().toISOString(),
                outExFile: null,
            };
          }else {
            //具有ID編號(修改項)
            //修改文章內容
            //若進入修改文章內容時，清除暫存ID
            this.tempId = "";
          try {
            this.contentDetail = {};
            let jsonReq = {
              TYPE: "SELECT",
              VerifyCode:this.PJ_ID,
              LatestNews_SELECT: {
                id: this.id,
                typeId: this.typeId,
                langurage: this.lang,
              },
            };
            let resToken = await this.userRequest.post(
                "bicd/Token"
            ); 
            jsonReq.Token = resToken.data;
            let res = await this.userRequest.post(
                "bicd/LatestNews",
                jsonReq
            );
            let json = JSON.parse(res.data);
            if (json.Status) {
              let jsonData = JSON.parse(json.Data);
 
              if(jsonData) {
                this.contentDetail = jsonData;
                  //取得圖檔列表
                this.getSelectFile();
              }
            }
          } catch (err) {
              console.log(err);
          }
        }
        }
      },
      functionDelete(item) {
        this.deleteModal.show = true;
        this.deleteModal.id = item.id;
        this.deleteModal.type = "LatestNews";
        this.deleteModal.langurage = this.lang;
        this.deleteModal.VerifyCode = this.PJ_ID;
      },
      save() {
        //將目前資訊整合，並送出
        //清除舊有FormData資料紀錄
        this.formData = new FormData();
        this.formData.append("id",this.id);
        this.formData.append("TYPE", "SAVE");
        this.formData.append("VerifyCode", this.PJ_ID);
        this.formData.append("langurage", this.lang);
        this.formData.append("typeId", this.typeId);
        this.formData.append("model", this.modal);
        this.formData.append("title", this.contentDetail.title);
        this.formData.append("startDate", this.contentDetail.startDate);
        this.formData.append("endDate", this.contentDetail.endDate);
        this.formData.append("deployStatus", this.contentDetail.deployStatus);
        this.formData.append("sort", this.contentDetail.sort);
        this.formData.append("publicUnit", this.contentDetail.publicUnit);
        this.formData.append("httpPostedFile", this.contentDetail.file);
        this.formData.append("tempId",this.tempId);
        this.FunctionToken(this.functionSaveContent, {});
      },
      //新增/修改功能
      functionSaveContent(data) {
        this.formData.append("Token",data.Token);
        this.apiLatestNews2(this.formData)
          .then((res) => {
            this.formData = new FormData();
            let json = JSON.parse(res.data);
            if (json.Status) {
              this.$bvToast.toast("儲存成功", {
                title: "提示",
                solid: true,
              });
              this._go("?lang="+this.lang+"&PJID="+this.PJ_ID+"&modal="+ this.modal);
            } else {
              alert(this.Str_Replace(JSON.parse(json.Data), ",", "\r\n"));
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      },
      //上傳檔案列表功能
      getSelectFile() {
        let json = {
          TYPE: "SELECT_TEMP",
          VerifyCode: this.PJ_ID,
          latestnews_file_SELECT: {
            articleId: (this.id)?Number(this.id):null,
            tempId: this.tempId,
            fileLang: this.lang,
          },
        };
        
        this.FunctionToken(this.functionSelectTempFile, json);
      },
      functionSelectTempFile(data) {
        this.apiLatestNewsFile(data)
          .then((res) => {
            let json = JSON.parse(res.data);
            if (json.Status) {
              let jsonData = JSON.parse(json.Data);
              this.contentDetail.outExFile = jsonData;
              this.$forceUpdate();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      //上傳檔案必填欄位判斷
      uploadSaveFile() {
        if (this.uploadFile.fileName == null) {
          alert('請上傳檔案');
        } else {
          this.formData = new  FormData();
          this.formData.append("VerifyCode",this.PJ_ID);
          this.formData.append("TYPE", "INSERT");
          this.formData.append("articleId", (this.id)?Number(this.id):null);
          this.formData.append("tempId", this.tempId);
          this.formData.append("fileLang", this.lang);
          this.formData.append("httpPostedFile", this.uploadFile.fileName);
          this.FunctionToken(this.functionSaveContent2, {});
        }
      },
      //上傳檔案新增功能
      functionSaveContent2(data) {
        this.formData.append("Token", data.Token);
        this.apiLatestNewsFile2(this.formData)
          .then((res) => {
            let json = JSON.parse(res.data);
            this.formData = new FormData();
            if (json.Status) {
              this.$bvToast.toast('上傳成功', {
                title: '提示',
                solid: true
              })
              this.uploadFileShow = false;
              this.uploadFile = {};

              this.getSelectFile();
            } else {
              alert(JSON.parse(json.Data))
            }
            
            this.uploading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      },
      DeleteFile(item) {
        if(confirm("確認刪除 "+ item.fileName + " 嗎?")){
          this.deleteConfirm = false;
          let json = {
            TYPE: "DELETE",
            VerifyCode: this.PJ_ID,
            latestnews_file_DELETE: {
              id: item.id,
              tempId: this.id ,
              fileLang: this.lang,
            },
          }
          this.FunctionToken(this.functionDeleteFile, json);
        }
      },
      functionDeleteFile(data) {
        this.apiLatestNewsFile(data)
          .then((res) => {
            let json = JSON.parse(res.data);
            if (json.Status) {
              /*this.$bvToast.toast('刪除檔案成功', {
                title: '提示',
                solid: true
              })*/
              alert("刪除檔案成功");

              this.getSelectFile();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      },
      cancelSearch () {
        this.search = {status: null,langurage: null};
        this.init();
      },
      //切換語系
      toLang(click_lang){
        
        if(click_lang == 'tw' && this.lang != '1'){
            //進入中文介面 
            if (this.isEdited){
                //確認是否不儲存就離開
                if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                    return;
                }
            }
            this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=1");
            
        }else if(click_lang == 'en'&& this.lang != '2'){
            //進入英文介面
            if(this.isEdited){
                //確認是否不儲存就離開
                if(!confirm("還有尚未儲存的資料，請問是否直接離開")){
                    return;
                }
            }
            this._go("?PJID="+this.PJ_ID + "&typeId="+this.typeId +"&modal="+this.modal+((this.id != undefined && this.id != '')?"&id="+this.id:"")+"&lang=2");
        }
      },
    },
  };

</script>
